var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("input", {
    directives: [
      {
        name: "money",
        rawName: "v-money",
        value: {
          precision: _vm.precision,
          decimal: _vm.decimal,
          thousands: _vm.thousands,
          prefix: _vm.prefix,
          suffix: _vm.suffix,
          allowBlank: _vm.allowBlank,
          maxLength: _vm.maxLength,
        },
        expression:
          "{ precision, decimal, thousands, prefix, suffix, allowBlank, maxLength }",
      },
    ],
    staticClass: "v-money",
    attrs: { type: "text" },
    domProps: { value: _vm.formattedValue },
    on: { change: _vm.change },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }